import {combineReducers} from 'redux'
import types from 'actions/types'
import {createPivotTableReducer} from 'reducers/pivotTable'
import {createNewHistoryItem} from 'containers/quoteEditor/components/quoteHistoryView/columnDefinition'
import Immutable from 'seamless-immutable'
import {set} from 'lodash'
import {getNumberFromLetterSequence} from 'helpers/string'
import {DataType} from 'helpers/socket'

export const isLoading = (state = false, action) => {
  switch (action.type) {
    case types.PURCHASING_LOAD_PURCHASE_ORDER_ATTEMPT:
      return true
    case types.PURCHASING_LOAD_PURCHASE_ORDER_SUCCESS:
      return false
    case types.PURCHASING_LOAD_PURCHASE_ORDER_FAILURE:
      return false
    default:
      return state
  }
}

const contactId = (state = null, action) => {
  switch (action.type) {
    case types.PURCHASING_SET_SELECTED_CONTACT:
      return action.contactId
    default:
      return state
  }
}

const companyId = (state = null, action) => {
  switch (action.type) {
    case types.PURCHASING_SET_SELECTED_CONTACT:
      return action.companyId
    default:
      return state
  }
}

export const purchaseOrder = (state = null, action) => {
  switch (action.type) {
    case types.CONTACTS_DETAILS_CONTACT_LOAD_ATTEMPT:
      return null
    case types.PURCHASING_UNLOAD_PURCHASE_ORDER:
      return null
    case types.PURCHASING_LOAD_PURCHASE_ORDER_ATTEMPT:
      return null
    case types.PURCHASING_LOAD_PURCHASE_ORDER_SUCCESS:
      return action.data
    case types.PURCHASING_LOAD_PURCHASE_ORDER_FAILURE:
      return null
    case types.PURCHASING_ADD_PURCHASE_ORDER_SUCCESS:
      return action.data
    case types.PURCHASING_PURCHASE_ORDER_CHANGE_STATUS_SUCCESS:
      return action.data.result
    case types.PURCHASING_PURCHASE_ORDER_UPDATE_ATTEMPT:
      return action.order
    case types.PURCHASING_PURCHASE_ORDER_UPDATE_PROPERTY:
      return set({...state}, action.key, action.value)
    case types.PURCHASING_PURCHASE_ORDER_SAVE_SUCCESS:
      return {
        ...state,
        ...action.data.result,
      }
    default:
      return state
  }
}

const deletedItems = (state = Immutable([]), action) => {
  switch (action.type) {
    case types.PURCHASING_LOAD_PURCHASE_ORDER_SUCCESS:
    case types.PURCHASING_LOAD_PURCHASE_ORDER_ATTEMPT:                              // reset when loading another PO
    case types.PURCHASING_PURCHASE_ORDER_SAVE_SUCCESS:
      return Immutable([])    // reset if or when saved changes

    case types.PURCHASING_PURCHASE_ORDER_DELETE_ORDER_ITEM:
      return Immutable([
        ...state,
        action.orderItem.id,
      ])
    case types.PURCHASING_PURCHASE_ORDER_DELETE_ORDER_ITEMS:
      return Immutable([
        ...state,
        ...action.orderItems.map(i => i.id),
      ])
    default:
      return state
  }
}

const folders = (state = [], action) => {
  switch (action.type) {
    case types.PURCHASING_LOAD_PURCHASE_ORDER_ATTEMPT:
      return []
    case types.PURCHASING_PURCHASE_ORDER_DOCUMENTS_ADD_FOLDER:
      return [
        ...state,
        action.folder,
      ]
    case types.PURCHASING_PURCHASE_ORDER_DOCUMENTS_SET_FOLDERS_TO_ROOT_DIRECTORY:
      return [action.folder]
    case types.PURCHASING_PURCHASE_ORDER_DOCUMENTS_REMOVE_FOLDERS_AFTER_INDEX:
      return state.slice(0, action.index)
    default:
      return state
  }
}

const rootFolder = (state = null, action) => {
  switch (action.type) {
    case types.PURCHASING_LOAD_PURCHASE_ORDER_ATTEMPT:
      return null
    case types.PURCHASING_PURCHASE_ORDER_DOCUMENTS_SET_FOLDERS_TO_ROOT_DIRECTORY:
      return action.folder
    case types.PURCHASING_PURCHASE_ORDER_DOCUMENTS_LOAD_PARENT_FOLDER_SUCCESS:
      return state === null
          ? action.folder
          : state
    default:
      return state
  }
}

const currentFolder = (state = null, action) => {
  switch (action.type) {
    case types.PURCHASING_LOAD_PURCHASE_ORDER_ATTEMPT:
      return null
    case types.PURCHASING_PURCHASE_ORDER_DOCUMENTS_SET_FOLDERS_TO_ROOT_DIRECTORY:
      return action.folder
    case types.PURCHASING_PURCHASE_ORDER_DOCUMENTS_LOAD_PARENT_FOLDER_SUCCESS:
      return action.folder
    case types.PURCHASING_PURCHASE_ORDER_DOCUMENTS_ADD_FOLDER:
      return action.folder
    default:
      return state
  }
}

const subFolder = (state = null, action) => {
  switch (action.type) {
    case types.PURCHASE_ORDERS_DOCUMENTS_SET_SELECTED_SUB_FOLDER:
      return action.path
    default:
      return state
  }
}

const observingUsers = (state = {}, action) => {
  switch (action.type) {
    case types.USERS_OBSERVING_PURCHASE_ORDER:
      return action.users

    case types.USERS_OBSERVING:
      return action.dataType === DataType.PURCHASE_ORDER
          ? action.users
          : state

    case types.DEOBSERVE:
      return action.dataType === DataType.PURCHASE_ORDER
          ? {}
          : state

    default:
      return state
  }
}

export const changeLogOrder = (state = Immutable([]), action) => {
  switch (action.type) {
    case types.PURCHASING_LOAD_PURCHASE_ORDER_SUCCESS:
      return Immutable([action.data])
    case types.PURCHASING_LOG_CHANGE:
      return Immutable([...state, action.order])
    case types.PURCHASING_UNDO_CHANGE:
      return Immutable(state.slice(0, -1))
    default:
      return state
  }
}

export const changeLogOrderItems = (state = Immutable([]), action) => {
  switch (action.type) {
    case types.PIVOT_TABLE_LOAD_SUCCESS:
      if (action.key === purchaseOrderItemsPivotTableKey) {
        return Immutable([action.data])
      }
      return state
    case types.PURCHASING_LOAD_PURCHASE_ORDER_SUCCESS:
      return Immutable([action.data])
    case types.PURCHASING_LOG_CHANGE:
      return Immutable([...state, action.orderItems])
    case types.PURCHASING_UNDO_CHANGE:
      return Immutable(state.slice(0, -1))
    case types.PURCHASING_PURCHASE_ORDER_CHANGE_STATUS_ATTEMPT:
      return Immutable([])
    default:
      return state
  }
}

const currentTab = (state = Immutable('order'), action) => {
  switch (action.type) {
    case types.NAVIGATION_SET_SELECTED_PURCHASING_TAB:
      return action.tab
    default:
      return state
  }
}

const currentDetailsTab = (state = Immutable('Order'), action) => {
  switch (action.type) {
    case types.PURCHASING_SET_DETAILS_TAB:
      return action.tab
    default:
      return state
  }
}

const acceptanceUrl = (state = null, action) => {
  switch (action.type) {
    case types.PURCHASING_LOAD_PURCHASE_ORDER_ACCEPTANCE_URL_ATTEMPT:
      return null
    case types.PURCHASING_LOAD_PURCHASE_ORDER_ACCEPTANCE_URL_SUCCESS:
      return action.url
    case types.PURCHASING_LOAD_PURCHASE_ORDER_ACCEPTANCE_URL_FAILURE:
      return null
    default:
      return state
  }
}

export const createNewItem = (item, state) => ({
  ...item,
  itemId: state.length + 1,
  lineItemLetter: getNumberFromLetterSequence(state.length + 1),
})

export const purchaseOrderItemsPivotTableKey = 'purchasingContext.selected.items'
export const purchaseOrderDocumentsPivotTableKey = 'purchasingContext.selected.documents'
export const purchaseOrderNewDocumentsPivotTableKey = 'purchasingContext.selected.newDocuments'
export const purchaseOrderInvoicesPivotTableKey = 'purchasingContext.selected.invoices'
export const purchaseOrderHistoryPivotTableKey = 'purchasingContext.selected.history'

export default combineReducers({
  isLoading,
  purchaseOrder,
  contactId,
  companyId,
  deletedItems,
  folders,
  rootFolder,
  currentFolder,
  subFolder,
  items: createPivotTableReducer({
    key: purchaseOrderItemsPivotTableKey,
    defaultSortColumn: 'itemId',
    defaultSortDirection: Immutable('asc'),
    pageSize: 50,
    defaultGridStretch: false,
    defaultAreAllRowsSelected: false,
    defaultCanSelectRows: false,
    retainEdits: false,
    onNewEntity: createNewItem,
  }),
  documents: createPivotTableReducer({key: purchaseOrderDocumentsPivotTableKey, defaultSortColumn: 'folderName'}),
  newDocuments: createPivotTableReducer({key: purchaseOrderNewDocumentsPivotTableKey, defaultSortColumn: 'folderName'}),
  invoices: createPivotTableReducer({
    key: purchaseOrderInvoicesPivotTableKey,
    defaultSortColumn: 'createdDate',
    defaultSortDirection: 'desc',
  }),
  history: createPivotTableReducer({
    key: purchaseOrderHistoryPivotTableKey,
    defaultSortColumn: 'timestamp',
    defaultSortDirection: 'desc',
    pageSize: 50,
    defaultGridStretch: false,
    defaultAreAllRowsSelected: false,
    defaultCanSelectRows: false,
    retainEdits: false,
    onNewEntity: createNewHistoryItem,
  }),
  observingUsers,
  changeLogOrder,
  changeLogOrderItems,
  currentTab,
  currentDetailsTab,
  acceptanceUrl,
})
